import { Anchor, Box, Menu, Text, TextProps } from 'grommet';

interface IMenuItemProps {
  label: string;
  disabled?: boolean;
  onClick?: () => void;
  id?: string;
  color?: string;
}

interface IMenuProps {
  label: string;
  icon?: React.ReactNode;
  items: IMenuItemProps[];
  textColor?: TextProps['color'];
  disabled?: boolean;
}

export const MenuWithChildren = ({ label, items, icon, textColor, disabled }: IMenuProps) => {
  return(
    <Menu
      plain
      items={items}
      icon={icon}
      label={<Text color={textColor}>{label}</Text>}
      dropProps={{ a11yTitle: label, gap: 'small', pad: 'small', background: 'dark-1' }}
      disabled={disabled}
    >
      <Anchor>
        <Box pad="medium" direction="row" gap="small" align="center">
          {icon}
          <Text size="1rem" weight={500} color={textColor}>
            {' '}
            {label}
          </Text>
        </Box>
      </Anchor>
    </Menu>
  );
};
